(() => {
  if (!customElements.get('phone-shop-header'))
    customElements.define(
      'phone-shop-header',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const opts = { signal: this.controller.signal };
          const wide = () => matchMedia('(min-width:961px)').matches;
          this.addEventListener(
            'change',
            (e) => {
              if (e.target.name === 'locale_code') e.target.form?.requestSubmit();
            },
            opts,
          );
          this.open = (group) => {
            if (!wide() || this.navigationPending) return;
            clearTimeout(this.timer);
            this.querySelectorAll('.sf-hover-group').forEach((g) => {
              const active = g === group;
              g.querySelector('.sf-live-mega').hidden = !active;
              g.querySelector('.sf-nav-trigger').setAttribute('aria-expanded', String(active));
              g.classList.toggle('is-open', active);
            });
          };
          this.close = () => {
            clearTimeout(this.timer);
            this.querySelectorAll('.sf-hover-group').forEach((g) => {
              g.querySelector('.sf-live-mega').hidden = true;
              g.querySelector('.sf-nav-trigger').setAttribute('aria-expanded', 'false');
              g.classList.remove('is-open');
            });
          };
          this.addEventListener(
            'pointerover',
            (e) => {
              const trigger = e.target.closest('.sf-nav-trigger');
              if (trigger?.closest('.sf-hover-group') && matchMedia('(hover:hover) and (pointer:fine)').matches)
                this.open(trigger.parentElement);
              else if (e.target.closest('.sf-header-tools,.sf-sell-link,.sf-logo')) this.close();
            },
            opts,
          );
          this.addEventListener(
            'pointerleave',
            () => {
              this.navigationPending = false;
              this.timer = setTimeout(this.close, 140);
            },
            opts,
          );
          this.addEventListener(
            'click',
            (e) => {
              if (e.target.closest('.sf-navigation a,.sf-native-menu-panel a')) {
                this.navigationPending = true;
                this.close();
                this.querySelectorAll('details[open]').forEach((d) => (d.open = false));
              }
            },
            opts,
          );
          this.addEventListener('pointerenter', () => clearTimeout(this.timer), opts);
          this.addEventListener(
            'focusin',
            (e) => {
              const trigger = e.target.closest('.sf-nav-trigger');
              if (trigger?.closest('.sf-hover-group')) this.open(trigger.parentElement);
            },
            opts,
          );
          this.addEventListener(
            'focusout',
            (e) => {
              if (!this.contains(e.relatedTarget)) this.close();
            },
            opts,
          );
          this.addEventListener(
            'keydown',
            (e) => {
              if (e.key === 'ArrowDown' && e.target.matches('.sf-hover-group > .sf-nav-trigger')) {
                e.preventDefault();
                this.open(e.target.parentElement);
                e.target.parentElement.querySelector('.sf-live-mega a')?.focus();
              }
              if (e.key === 'Escape') {
                const trigger = this.querySelector('.is-open .sf-nav-trigger');
                this.close();
                this.querySelectorAll('details[open]').forEach((d) => (d.open = false));
                trigger?.focus();
                this.close();
              }
            },
            opts,
          );
          document.addEventListener(
            'click',
            (e) => {
              if (!this.contains(e.target)) {
                this.close();
                this.querySelectorAll('details[open]').forEach((d) => (d.open = false));
              }
            },
            opts,
          );
          window.addEventListener(
            'resize',
            () => {
              if (!wide()) this.close();
            },
            opts,
          );
          this.addEventListener(
            'shopify:block:select',
            (e) => {
              const child = e.target.closest('.sf-image-menu-link');
              const group = e.target.closest('.sf-hover-group');
              if (wide() && group) this.open(group);
              else if (!wide()) {
                const menu = this.querySelector('.sf-native-menu');
                if (menu) menu.open = true;
                child?.closest('details')?.setAttribute('open', '');
              }
            },
            opts,
          );
          this.addEventListener('shopify:section:deselect', this.close, opts);
          this.addEventListener(
            'click',
            (e) => {
              const link = e.target.closest('#cart-icon-bubble'),
                drawer = document.querySelector('cart-drawer');
              if (link && drawer) {
                e.preventDefault();
                drawer.open(link);
              }
            },
            opts,
          );
        }
        disconnectedCallback() {
          this.controller?.abort();
          clearTimeout(this.timer);
        }
      },
    );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape')
      document.querySelectorAll('.sf-quick-filters details[open]').forEach((d) => {
        d.open = false;
        d.querySelector('summary')?.focus();
      });
  });
  document.addEventListener('click', (e) =>
    document.querySelectorAll('.sf-quick-filters details[open]').forEach((d) => {
      if (!d.contains(e.target)) d.open = false;
    }),
  );

  document.addEventListener('keydown', () => document.documentElement.setAttribute('data-sf9-input', 'keyboard'));
  document.addEventListener('pointerdown', () => document.documentElement.removeAttribute('data-sf9-input'));
  document.addEventListener(
    'submit',
    (event) => {
      if (event.target.matches('form[action*="/localization"]'))
        event.target
          .querySelector('[data-localization-return]')
          ?.setAttribute('value', location.pathname + location.search);
    },
    true,
  );
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sf8-lang[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape')
      document.querySelectorAll('.sf8-lang[open]').forEach((menu) => {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
  });
  document.addEventListener('pointerover', (event) => {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const picture = event.target.closest('[data-secondary-src]');
    if (!picture || picture.querySelector('.sf9-secondary-photo')) return;
    const img = document.createElement('img');
    img.className = 'sf9-secondary-photo';
    img.alt = '';
    img.width = 500;
    img.height = 500;
    img.src = picture.dataset.secondarySrc;
    picture.append(img);
  });
  const header = document.querySelector('.sf-header');
  if (header) {
    const sync = () =>
      document.documentElement.style.setProperty(
        '--sf8-header-offset',
        Math.ceil(header.getBoundingClientRect().height) + 'px',
      );
    new ResizeObserver(sync).observe(header);
    sync();
  }
})();

/* Mega menu, third level: hovering or focusing a category (Smartphones, Laptops…) shows its brand cards.
 * A short delay keeps the panel steady while the pointer moves diagonally towards the cards. */
(() => {
  let timer;
  const show = (cat) => {
    const menu = cat.closest('[data-mega3]');
    if (!menu || cat.classList.contains('is-active')) return;
    menu.querySelectorAll('[data-mega-cat]').forEach((c) => c.classList.toggle('is-active', c === cat));
    menu.querySelectorAll('[data-mega-panel]').forEach((p) => (p.hidden = p.dataset.megaPanel !== cat.dataset.megaCat));
  };
  document.addEventListener('pointerover', (e) => {
    const cat = e.target.closest?.('[data-mega-cat]');
    if (cat) {
      clearTimeout(timer);
      timer = setTimeout(() => show(cat), 70);
    } else if (e.target.closest?.('.sf-mega3-panels')) clearTimeout(timer);
  });
  document.addEventListener('focusin', (e) => {
    const cat = e.target.closest?.('[data-mega-cat]');
    if (cat) show(cat);
  });
})();
